<div #refModalTrigger class="btn-container" (click)="openFile()"><ng-content select="[trigger]"></ng-content></div>

@if ((refModalTrigger.children.length == 0)) {
  <button
    type="button"
    nz-button
    nzType="link"
    (click)="openFile()"
    [attr.aria-label]="text || tooltipTitle"
    nz-tooltip
    [nzTooltipTitle]="tooltipTitle"
  >
    @if (text) {
      <span>{{ text }}</span>
    }
    <i
      nz-icon
      [nzType]="icon"
      nzTheme="outline"
    ></i>
  </button>
}
